/* tslint:disable */
/* eslint-disable */
/**
 * Salv AML Platform internal API
 * Salv AML Platform internal API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { InternalApiFinalRiskRangeEntry } from './InternalApiFinalRiskRangeEntry';
import {
    InternalApiFinalRiskRangeEntryFromJSON,
    InternalApiFinalRiskRangeEntryFromJSONTyped,
    InternalApiFinalRiskRangeEntryToJSON,
    InternalApiFinalRiskRangeEntryToJSONTyped,
} from './InternalApiFinalRiskRangeEntry';

/**
 * 
 * @export
 * @interface InternalApiSetFinalRiskRangesRequest
 */
export interface InternalApiSetFinalRiskRangesRequest {
    /**
     * 
     * @type {Array<InternalApiFinalRiskRangeEntry>}
     * @memberof InternalApiSetFinalRiskRangesRequest
     */
    ranges: Array<InternalApiFinalRiskRangeEntry>;
}

/**
 * Check if a given object implements the InternalApiSetFinalRiskRangesRequest interface.
 */
export function instanceOfInternalApiSetFinalRiskRangesRequest(value: object): value is InternalApiSetFinalRiskRangesRequest {
    if (!('ranges' in value) || value['ranges'] === undefined) return false;
    return true;
}

export function InternalApiSetFinalRiskRangesRequestFromJSON(json: any): InternalApiSetFinalRiskRangesRequest {
    return InternalApiSetFinalRiskRangesRequestFromJSONTyped(json, false);
}

export function InternalApiSetFinalRiskRangesRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): InternalApiSetFinalRiskRangesRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'ranges': ((json['ranges'] as Array<any>).map(InternalApiFinalRiskRangeEntryFromJSON)),
    };
}

export function InternalApiSetFinalRiskRangesRequestToJSON(json: any): InternalApiSetFinalRiskRangesRequest {
    return InternalApiSetFinalRiskRangesRequestToJSONTyped(json, false);
}

export function InternalApiSetFinalRiskRangesRequestToJSONTyped(value?: InternalApiSetFinalRiskRangesRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'ranges': ((value['ranges'] as Array<any>).map(InternalApiFinalRiskRangeEntryToJSON)),
    };
}

